import { RadioGridPresenter } from '@/forms/components/presenters/RadioGridPresenter';
import { FormFieldType, type RadioGridFormField } from '@/forms/typings';

import type { FormFieldModule } from '../registry/field-module.types';

import { buildRadioGridInitialState } from './initialState';

export const radioGridFieldModule: FormFieldModule = {
  type: FormFieldType.RadioGrid,
  Presenter: ({ field }) => (
    <RadioGridPresenter field={field as RadioGridFormField} />
  ),
  flattenLeaves: (field, ctx) => ctx.recurse((field as RadioGridFormField).fields),
  buildInitialState: buildRadioGridInitialState,
};
